export function roundPriceUtil(price: string) {
  // Find the separator (comma or period) if it exists
  const dotIndex = price.lastIndexOf('.');
  const commaIndex = price.lastIndexOf(',');

  // No decimal separator, return price
  if (dotIndex === -1 && commaIndex === -1) return price;

  // Use the rightmost separator
  const separatorIndex = Math.max(dotIndex, commaIndex);

  // If it's the last character, return the original string
  if (separatorIndex === price.length - 1) return price + '00';

  // Check how many characters are after the separator
  const charsAfterSeparator = price.length - separatorIndex - 1;

  if (charsAfterSeparator > 2) {
    // Remove all characters after the second digit
    return price.slice(0, separatorIndex + 3);
  } else if (charsAfterSeparator === 1) {
    // Add a zero if there's only 1 digit after the separator
    return price + '0';
  }

  // Otherwise return the original price
  return price;
}

// test(
//   roundPriceUtil('€ 13,5891239123')
//   '\n',
//   roundPriceUtil('€ 13,509'),
//   '\n',
//   roundPriceUtil('€ 13,50'),
//   '\n',
//   roundPriceUtil('€ 13,5'),
//   '\n',
//   roundPriceUtil('€ 13,'),
//   '\n',
//   roundPriceUtil('€ 13'),
//   '\n',
//   roundPriceUtil('$ 13,509'),
//   '\n',
//   roundPriceUtil('$ 13,50'),
//   '\n',
//   roundPriceUtil('$ 13,5'),
//   '\n',
//   roundPriceUtil('$ 13,'),
//   '\n',
//   roundPriceUtil('$ 13'),
//   '\n',
//   roundPriceUtil('€ 13,309'),
//   '\n',
//   roundPriceUtil('€ 13,30'),
//   '\n',
//   roundPriceUtil('€ 13,3'),
//   '\n',
//   roundPriceUtil('€ 13,'),
//   '\n',
//   roundPriceUtil('€ 13'),
//   '\n',
//   roundPriceUtil('$ 13,309'),
//   '\n',
//   roundPriceUtil('$ 13,30'),
//   '\n',
//   roundPriceUtil('$ 13,3'),
//   '\n',
//   roundPriceUtil('$ 13,'),
//   '\n',
//   roundPriceUtil('$ 13'),
//   '\n',
// );
